import {config, request, objectSerial} from 'Utils';

// 退货列表
export function fetchList(param) {
    return request(`${config.server}/api/v1/dms/dmsOrderGoback/list`, {
        method: 'post',
        body: param
    });
}

// 退货明细报表
export function detailReportList(param) {
    return request(`${config.server}/api/v1/dms/dmsOrderGoback/detailReport`, {
        method: 'post',
        body: param
    });
}

// 退货详情
export function fetchOrderDetail(param) {
    return request(`${config.server}/api/v1/dms/dmsOrderGoback/detail`, {
        search: param
    });
}

// 退货物料
export function fetchOrderList(param) {
    return request(`${config.server}/api/v1/dms/dmsOrderGoback/getRefundDetailLine`, {
        search: param
    });
}

// 搜索退货物料列表
export function fetchOrders(param) {
    return request(`${config.server}/api/v1/dms/dmsOrderGoback/getRefundItmeLine`, {
        method: 'post',
        body: param
    });
}

// 购货单位
export function purchaseUnit(param) {
    return request(`${config.server}/api/v1/dms/tzOrderTraceHeadBack/purchase`, {
        body: param
    });
}

// 退货子库
export function returnSubbank(param) {
    return request(`${config.server}/api/v1/dms/dmsTianSubStore/listByPage`, {
        method: 'post',
        body: param
    });
}

// 退货地点
export function returnAddress() {
    return request(`${config.server}/api/v1/dms/dmsOrderGoback/getReturnAddress`);
}

// 添加退货物料/api/v1/dms/tgOrder/getAd
export function addQualityItem(param, search) {
    return request(`${config.server}/api/v1/dms/dmsOrderGoback/addQualityItem`, {
        method: 'post',
        search,
        body: param
    });
}

// 退货物料列表
export function findQualityItem(param) {
    return request(`${config.server}/api/v1/dms/dmsOrderGoback/findQualityItem`, {
        method: 'post',
        body: param
    });
}

// 删除退货物料列表项
export function delOrderGobackItem(param) {
    return request(`${config.server}/api/v1/dms/dmsOrderGoback/delOrderGobackItem`, {
        method: 'post',
        body: param
    });
}

// 更新退货数量和问题描述
export function updateOrderGobackItem(param) {
    return request(`${config.server}/api/v1/dms/dmsOrderGoback/updateOrderGobackItem`, {
        method: 'post',
        body: param
    });
}

// 获取详情头
export function details() {
    return request(`${config.server}/api/v1/dms/dmsOrderGoback/getReturnCusInfo`);
}

// 退货提交和保存
export function submitDetails(param) {
    return request(`${config.server}/api/v1/dms/dmsOrderGoback/submitOrderGoback`, {
        method: 'post',
        body: param
    });
}

//退货确认
export function returnConfirmation(param) {
    return request(`${config.server}/api/v1/dms/dmsOrderGoback/confirm`, {
        method: 'post',
        body: param
    });
}

export function deleteGoods(param) {
    return request(`${config.server}/api/v1/dms/dmsOrderGoback/delete`, {
        method: 'get',
        body: param
    });
}

// // 退货驳回提交
// export function submitBefore(param) {
//   return request(`${config.server}/api/v1/dms/dmsOrderGoback/submitOrderGoback`,{
//     method: 'post',
//     body: param
//   });
// }


// WEBPACK FOOTER //
// ./src/service/returnGoods/index.js